module.exports = __webpack_public_path__ + "img/chevron-left-solid.7076bc47.svg";